import * as React from "react";
import * as JSON from "util/json";
import ClipboardButton from "./ClipboardButton";
const JSONClipboardButton = ({ content, ...rest }) => /* @__PURE__ */ React.createElement(ClipboardButton, { text: JSON.stringify(content, null, 2), ...rest });
export default JSONClipboardButton;
